import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./SkipToContentLink.css";
import globalStyles from "styles/global.css";

export default function SkipToContentLink({ href, className }) {
  return (
    <a
      href={href}
      className={classNames(
        "gtm-skip-to-content",
        className,
        styles.item,
        globalStyles.a11yOnlyFocusable
      )}
    >
      Skip to content
    </a>
  );
}

SkipToContentLink.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
};
